import { FC, useEffect, useState } from "react";
import classes from './addAccrualTutor.module.scss'
import { Modal } from "../../../shared/ui/modal";
import { MyButton } from "../../../shared/ui/button";
import { MyInput } from "../../../shared/ui/input";
import { useGlobalLoadingActions } from "../../../entities/globalLoading";
import { useGlobalMessageActions } from "../../../entities/globalMessage";
import { tutorService } from "../../../entities/tutor";
import { MyError } from "../../../shared/lib/error/MyError";
import { AuthError } from "../../../shared/lib/error/AuthError";
import { useMyActions } from "../../../entities/my";
import { MyTextarea } from "../../../shared/ui/myTextarea";

interface IProps {
    tutorId: number;
}

export const AddAccrualTutor: FC<IProps> = ({tutorId}) => {

    const [amount, setAmount] = useState<string>('')
    const [comment, setComment] = useState<string>('')
    const [error, setError] = useState<string>('')
    const [open, setOpen] = useState<boolean>(false)
    const {setIsLoading} = useGlobalLoadingActions()
    const {setGlobalMessage} = useGlobalMessageActions()
    const {setIsAuth} = useMyActions()

    const check = (): boolean => {
        if(!amount){
            setError('Введите сумму выплаты')
            return false
        }
        return true
    }

    const add = async () => {
        try{
            if(!check()){
                return
            }
            setIsLoading(true)
            await tutorService.addAccrual(tutorId, amount, comment)
            setGlobalMessage({message: 'Выплата успешно добавлена', type: 'ok'})
            setOpen(false)
        }
        catch(e){
            console.log(e)
            setOpen(false)
            if(e instanceof AuthError){
                setIsAuth(false)
                setGlobalMessage({message: e.message, type: 'error'})
            }
            else if(e instanceof MyError){
                setGlobalMessage({message: e.message, type: 'error'})
            }
            else{
                setGlobalMessage({message: 'Ошибка при добавлении выплаты', type: 'error'})
            }
        }
        finally{
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if(!open){
            setAmount('')
            setComment('')
            setError('')
        }
    }, [open])

    return (
        <section className={classes.container}>
            <section className={classes.button}>
                <MyButton 
                    onClick={() => setOpen(true)}
                >
                    Добавить выплату
                </MyButton>
            </section>
            <Modal
                open={open}
                setOpen={setOpen}
            >
                <section className={classes.content}>
                    <MyInput
                        title="Сумма выплаты"
                        type="number"
                        value={amount}
                        setValue={setAmount}
                        setError={setError}
                    />
                    <section>
                        <section className={classes.sign}>
                            Комментарий
                        </section>
                        <MyTextarea
                            value={comment}
                            setValue={setComment}
                            placeholder="Введите комментарий"
                        />
                    </section>
                    <section className={classes.submit}>
                        <MyButton
                            onClick={add}
                            error={error}
                        >
                            Добавить
                        </MyButton>
                    </section>
                </section>
            </Modal>
        </section>
    )
}
